import { vuexPto } from '@/store/compositionV2/module/pto'
import { PTOPPRApi } from '@/api/pto'
import { getUserFullName } from '@/utils/user'
import { requestEmail } from '@/store/compositionV2/utils/data/actions'
import { vuexSaveItemAndFiles } from '@/store/compositionV2/saveItemAndFiles'
import { vuexFileBase } from '@/store/compositionV2/utils/file'

const state = () => ({
  ...vuexPto.createState(),
  ...vuexFileBase.createState(),

  api: PTOPPRApi,
  namePageDetailed: 'PtoProjectPtoPPRUpdate',
  expand: 'developer,mol,files',
  tableHeaders: [
    {
      title: 'Дата выдачи ППР',
      isSortable: true,
      sortName: 'develop_date'
    },
    {
      title: 'Наименование ППР',
      isSortable: true,
      sortName: 'name'
    },
    {
      title: 'Разработчик ППР',
      isSortable: true,
      sortName: 'developer.surname'
    },
    {
      title: 'Мол',
      isSortable: true,
      sortName: 'mol.surname'
    },
    {
      title: 'Загружено файлов',
      isSortable: false
    }
  ]
})

const getters = {
  ...vuexPto.createGetters(),
  ...vuexFileBase.createGetters(),

  getList: state => {
    return state.list.map(item => {
      let filesCount = {
        count: '0 файлов'
      }
      if (item.files) {
        filesCount = {
          count: item.files.length + ' файлов'
        }
      }
      return {
        isControlsActive: item.isControlsActive,
        isActive: item.isActive,
        id: item.id,
        values: [
          item.develop_date || '-',
          item.name || '-',
          getUserFullName(item.developer) || '-',
          getUserFullName(item.mol) || '-',
          { data: filesCount, mod: 'countFiles' }
        ]
      }
    })
  }
}

const mutations = {
  ...vuexPto.createMutations(),
  ...vuexFileBase.createMutations()
}

const actions = {
  ...vuexPto.createActions(),
  ...vuexSaveItemAndFiles.createActions(),
  requestEmail
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
